import {
  COMMON_QUERY_CONFIG,
  COMMON_QUERY_RULES_CONFIG,
  COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
  COMMON_VIDEO_QUERY_RULES_CONFIG,
  ruleNewsPlus
} from './shared/configs';

enum SECTION_ENUM {
  WORLD = 'World',
  AFRICA = 'Africa',
  AMERICAS = 'Americas',
  ASIA = 'Asia',
  CHINA = 'China',
  EUROPE = 'Europe',
  MIDDLE_EAST = 'Middle East',
  INDIA = 'India',
  OCEANIA = 'Oceania',
  RUSSIA = 'Russia',
  UK = 'U.K.',
  DEFAULT = 'Default',
  RELATED_OPINION = 'Related Opinion',
  VIDEO = 'Video'
}

const WORLD = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? []), ruleNewsPlus],
    or: [
      { terms: { key: 'DJEThing', value: ['world'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['world/africa'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['world/americas'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['world/asia'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['world/china'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['world/europe'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['world/india'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['world/middle-east'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['world/oceania'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['world/russia'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['world/uk'] } }
    ]
  }
};

const RUSSIA = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['world/russia'] } }]
  }
};

const ASIA = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['world/asia'] } }]
  }
};

const EUROPE = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['world/europe'] } }]
  }
};

const MIDDLE_EAST = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['world/middle-east'] } }]
  }
};

const AMERICAS = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['world/americas'] } }]
  }
};

const INDIA = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['world/india'] } }]
  }
};

const CHINA = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['world/china'] } }]
  }
};

const OCEANIA = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['world/oceania'] } }]
  }
};

const UK = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['world/uk'] } }]
  }
};

const AFRICA = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['world/africa'] } }]
  }
};

const RELATED_OPINION = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
    and: [
      ...(COMMON_RELATED_OPINION_QUERY_RULES_CONFIG.and ?? []),
      // remove when allesseh fix is on prod
      // {
      //   terms: {
      //     key: 'SecondaryDJEThing',
      //     value: [
      //       'world',
      //       'world/africa',
      //       'world/americas',
      //       'world/asia',
      //       'world/china',
      //       'world/europe',
      //       'world/india',
      //       'world/middle-east',
      //       'world/oceania',
      //       'world/russia',
      //       'world/uk'
      //     ]
      //   }
      // }
      // Uncomment when allesseh fix is on prod
      // https://dowjones.slack.com/archives/C08D8JNSLHH/p1747074635532119?thread_ts=1747071615.929029&cid=C08D8JNSLHH
      {
        codes_with_significance: {
          key: 'djething',
          significance: ['significant'],
          value: [
            'world',
            'world/africa',
            'world/americas',
            'world/asia',
            'world/china',
            'world/europe',
            'world/india',
            'world/middle-east',
            'world/oceania',
            'world/russia',
            'world/uk'
          ]
        }
      }
    ],
    or: [],
    not: []
  }
};

const VIDEO = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_VIDEO_QUERY_RULES_CONFIG,
    or: [{ term: { key: 'DJEThing', value: 'world' } }, { prefix: { key: 'DJEThing', value: 'world/' } }],
    not: []
  }
};

export {
  SECTION_ENUM,
  WORLD,
  RUSSIA,
  ASIA,
  EUROPE,
  MIDDLE_EAST,
  AMERICAS,
  INDIA,
  CHINA,
  OCEANIA,
  UK,
  AFRICA,
  RELATED_OPINION,
  VIDEO
};
